var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavExplorer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M12,14.2c-0.5,0-0.9-0.4-0.9-0.9V9.9C11.1,9.4,11.5,9,12,9c0.7,0,0.9,0.4,0.9,0.9v3.3 C12.9,13.7,12.5,14.2,12,14.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M12,3.8c-0.5,0-0.9-0.4-0.9-0.9v-2C11.1,0.4,11.5,0,12,0c0.7,0,0.9,0.4,0.9,0.9v1.8 C12.9,3.3,12.5,3.8,12,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M5.7,14.2c-0.1,0-0.1,0-0.3,0.1l-1.6,1.8c-0.1,0.1-0.1,0.3,0,0.4l1.6,1.8c0,0.1,0.1,0.1,0.3,0.1h13.2 c0.1,0,0.3-0.1,0.3-0.3v-3.8c0-0.1-0.1-0.3-0.3-0.3H5.7z M18.7,20.3H5.5c-0.7,0-1.2-0.3-1.6-0.8l-1.6-1.7c-0.8-0.8-0.8-2,0-2.8 L4,13.2c0.4-0.5,0.9-0.8,1.6-0.8h13.2c1.2,0,2.2,0.9,2.2,2.2v3.7C20.8,19.4,20,20.3,18.7,20.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M12,24c-0.5,0-0.9-0.4-0.9-0.9v-3.3c0-0.5,0.4-0.9,0.9-0.9c0.7,0,0.9,0.4,0.9,0.9v3.3 C12.9,23.6,12.5,24,12,24"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    className: "needfill",
    d: "M18.3,8.6c0.1,0,0.1,0,0.3-0.1l1.6-1.8c0.1-0.1,0.1-0.3,0-0.4l-1.6-1.7c0-0.1-0.1-0.1-0.3-0.1H5.1 c0,0-0.1,0.1-0.1,0.3v3.8c0,0,0.1,0.1,0.3,0.1H18.3z M5.3,2.5h13.2c0.7,0,1.2,0.3,1.6,0.8l1.6,1.8c0.8,0.8,0.8,2,0,2.8L20,9.8 c-0.4,0.5-0.9,0.8-1.6,0.8H5.3C4.1,10.5,3,9.6,3,8.3V4.6C3.2,3.4,4,2.5,5.3,2.5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavExplorer);
export default __webpack_public_path__ + "static/media/nav_explorer.f412485d03b1d6bcf5869ef19838b1be.svg";
export { ForwardRef as ReactComponent };